<template>
  <div class="page-content user-interactions">
    <user-interactions-profile />
    <user-interactions-scheduled-ride />
    <caller-date-events />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const UserInteractionsScheduledRide = defineAsyncComponent(() => import('./UserInteractions/UserInteractionsScheduledRide.vue') as any);

const UserInteractionsProfile = defineAsyncComponent(() => import('./UserInteractions/UserInteractionsProfile.vue') as any);

const CallerDateEvents = defineAsyncComponent(() => import('./UserInteractions/CallerDateEvents.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
